export const CustomerItemSummaryColumns = [
  {
    id: "name",
    title: "Item Name",
  },
  {
    id: "type",
    title: "Unit",
  },
  {
    id: "price",
    title: "Price",
  },
  {
    id: "qty",
    title: "Qty",
  },
  {
    id: "amount",
    title: "Total",
  },
];
